import { rmmGetDescription as description } from './description';
import { getAlert as execute } from './execute';

export { description, execute };
